import { ReactNode } from 'react';

import { DrawerHeader as BaseDrawerHeader, Heading, cn } from '@growtherapy/sprout-ui';

import { useTheme } from '../hooks';
import { Theme } from '../state/theme';

type DrawerHeaderProps = Omit<Parameters<typeof BaseDrawerHeader>[0], 'children'>;
type HeadingProps = Omit<Parameters<typeof Heading>[0], 'children'>;

export function DrawerHeader({
  children,
  drawerHeaderProps,
  headingProps,
}: {
  children: ReactNode;
  drawerHeaderProps?: DrawerHeaderProps;
  headingProps?: HeadingProps;
}) {
  const { theme } = useTheme();
  const isDarkTheme = theme === Theme.DARK;

  return (
    <BaseDrawerHeader {...drawerHeaderProps}>
      <Heading
        as='h2'
        className={cn({
          'rebrand:text-text-inverse': isDarkTheme,
        })}
        {...headingProps}
      >
        {children}
      </Heading>
    </BaseDrawerHeader>
  );
}
